import Attachment from '../../types/attachment'
import AttachmentCard from './AttachmentCard'

interface Props {
  attachments?: Attachment[]
  className?: string
}

export default function AttacmentsOverview({ attachments, className }: Props) {
  return (
    <div
      className={`grid auto-rows-max auto-cols-auto gap-3 md:grid-cols-2 lg:grid-cols-3 px-4 ${className}`}
      id="attachments-list"
    >
      {attachments
        ?.sort((a, b) => +a.id - +b.id)
        .map((attachment) => (
          <AttachmentCard
            name={attachment.title}
            state={attachment.state}
            id={attachment.id}
            description={attachment.description}
            key={attachment.id}
          />
        ))}
    </div>
  )
}
